import styled from 'styled-components';
import { media } from 'designsystem';
import { bigImageWidth, mediumImageWidth, smallImageWidth } from 'common/consts/person-image';

const PersonImage = styled.img`
  object-fit: cover;
  height: ${smallImageWidth};
  width: ${smallImageWidth};
  
  ${media.tablet`
    height: ${mediumImageWidth};
    width: ${mediumImageWidth};
  `}
  
  ${media.desktop`
    height: ${bigImageWidth};
    width: ${bigImageWidth};
  `};
`;

export default PersonImage;



// WEBPACK FOOTER //
// ./src/kentico-blocks/CallUs/ContactPerson/PersonImage.jsx